import { gql } from '@apollo/client';

export const GET_PARK_ZONES = gql`
  query parkZonesV2($input: ParkZonesQueryInput!) {
    parkZonesV2(input: $input) {
      content {
        uid
        locationType
        visibility
        name
        address {
          street
          number
          city
          marker
        }
        countryCode
        commercialZoneView {
          zoneCode
          name
        }
        area
        parkingMethods {
          anpr
          unmanagedParking
          evCharging
        }
        markerType
      }
      totalPages
    }
  }
`;
